(function () {
  var EAN = /^\D*(\d{8,14})\D*$/;
  var busy = false;

  function go(code) { if (busy) return; busy = true; redirectToProduct(code); }

  function redirectToProduct(code) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'search?q=' + encodeURIComponent(code) + '&type=product&view=lookup')
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var urls = JSON.parse((t || '').trim());
        if (Array.isArray(urls) && urls[0]) { window.location.href = urls[0]; }
        else { window.location.href = root + 'search?q=' + encodeURIComponent(code); }
      })
      .catch(function () { window.location.href = root + 'search?q=' + encodeURIComponent(code); });
  }

  function isSearchField(el) {
    if (!el || !el.getAttribute) return false;
    return el.getAttribute('name') === 'q'
      || el.getAttribute('type') === 'search'
      || (el.closest && el.closest('predictive-search') !== null);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !isSearchField(e.target)) return;
    var m = (e.target.value || '').trim().match(EAN);
    if (!m) return;
    e.preventDefault(); e.stopImmediatePropagation();
    go(m[1]);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches("form[action*='/search']")) return;
    var input = form.querySelector("input[name='q'], input[type='search']");
    var m = input && (input.value || '').trim().match(EAN);
    if (!m) return;
    e.preventDefault(); e.stopImmediatePropagation();
    go(m[1]);
  }, true);

  var CAN_CAMERA = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
  var IS_TOUCH = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

  function camIcon() {
    return "<svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M3 7h3l1.5-2h9L18 7h3v12H3z'></path><circle cx='12' cy='13' r='3.5'></circle></svg>";
  }

  function makeCamButton(input) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Barcode scannen');
    btn.setAttribute('title', 'Barcode scannen');
    btn.innerHTML = camIcon();
    btn.style.cssText = 'display:flex;align-items:center;justify-content:center;background:none;border:0;cursor:pointer;padding:0 .5rem;color:inherit;-webkit-appearance:none;';
    btn.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); openScanner(input); });
    return btn;
  }

  function addScanButtons() {
    var buttons = document.querySelectorAll('button');
    for (var b = 0; b < buttons.length; b++) {
      var tb = buttons[b];
      var oc = tb.getAttribute('@click') || tb.getAttribute('x-on:click') || '';
      if (oc.indexOf('openSearch') === -1) continue;
      if (tb.dataset.bcCamTrigger) continue;
      tb.dataset.bcCamTrigger = '1';
      var holder = tb.parentNode;
      if (!holder) continue;
      try { if (getComputedStyle(holder).position === 'static') holder.style.position = 'relative'; } catch (e) {}
      var cb = makeCamButton(null);
      cb.style.cssText += 'position:absolute;right:.5rem;top:0;height:100%;z-index:5;';
      holder.appendChild(cb);
      tb.style.setProperty('padding-right', '3rem', 'important');
    }

    var inputs = document.querySelectorAll("#search-field, input[name='q'], input[type='search']");
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.dataset.bcCam) continue;
      input.dataset.bcCam = '1';
      var btn = makeCamButton(input);
      var wrap = input.parentNode;
      var rightCtrl = (wrap && wrap.querySelector) ? wrap.querySelector('.right-4') : null;
      if (rightCtrl) {
        rightCtrl.insertBefore(btn, rightCtrl.firstChild);
        input.style.setProperty('padding-right', '5.5rem', 'important');
      } else if (wrap) {
        try { if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative'; } catch (e) {}
        btn.style.cssText += 'position:absolute;right:.5rem;top:0;height:100%;';
        wrap.appendChild(btn);
        input.style.setProperty('padding-right', '3rem', 'important');
      }
    }
  }

  if (CAN_CAMERA && IS_TOUCH) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', addScanButtons);
    } else {
      addScanButtons();
    }
    var scheduled = false;
    var schedule = function () {
      if (scheduled) return;
      scheduled = true;
      var run = function () { scheduled = false; addScanButtons(); };
      if (window.requestAnimationFrame) { window.requestAnimationFrame(run); } else { setTimeout(run, 16); }
    };
    var mo = new MutationObserver(schedule);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  function isValidEan13(code) {
    if (!/^\d{13}$/.test(code)) return false;
    var sum = 0;
    for (var i = 0; i < 12; i++) { sum += (code.charCodeAt(i) - 48) * (i % 2 === 0 ? 1 : 3); }
    var check = (10 - (sum % 10)) % 10;
    return check === (code.charCodeAt(12) - 48);
  }

  function normalize(raw) {
    var code = String(raw || '').replace(/\D/g, '');
    if (code.length === 12) { code = '0' + code; }
    return code;
  }

  var activeStop = null;

  function closeScanner(overlay) {
    try { if (activeStop) activeStop(); } catch (e) {}
    activeStop = null;
    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    document.documentElement.style.overflow = '';
  }

  function accept(overlay, input, code) {
    closeScanner(overlay);
    if (input) { input.value = code; }
    go(code);
  }

  // ------------------------------------------------------------------
  // Detector-Initialisierung
  // Native BarcodeDetector API, wo sie EAN-13 kann (Android/Chrome).
  // Sonst (iOS/Safari, Desktop-Chrome ohne Backend): Polyfill
  // "barcode-detector" auf Basis von zxing-wasm (ZXing-C++ als WASM) –
  // deutlich stärkerer 1D-Decoder als der alte @zxing/library-JS-Port.
  // Das Polyfill registriert sich als window.BarcodeDetector, danach
  // läuft auf allen Plattformen exakt derselbe Scan-Code.
  // ------------------------------------------------------------------
  // Kompatibilitäts-Shims für das Polyfill auf älteren iOS-Versionen:
  // Object.hasOwn (fehlt vor iOS 15.4, einzige harte Abhängigkeit des
  // Builds) und globalThis (fehlt vor iOS 12.2). Auf modernen Geräten
  // sind beide No-ops. Senkt die Untergrenze des Scanners auf ~iOS 12.
  if (typeof globalThis === 'undefined') {
    try { window.globalThis = window; } catch (e) {}
  }
  if (!Object.hasOwn) {
    try {
      Object.defineProperty(Object, 'hasOwn', {
        value: function (obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); },
        writable: true,
        configurable: true
      });
    } catch (e) {}
  }

  // Versions-gepinnter IIFE-Build (klassisches Script, kein ES-Modul):
  // registriert das Global "BarcodeDetectionAPI". Die zugehörige WASM-Datei
  // (zxing_reader.wasm) lädt der Build zur Laufzeit von fastly.jsdelivr.net.
  var POLYFILL_URL = 'https://cdn.jsdelivr.net/npm/barcode-detector@3.2.1/dist/iife/ponyfill.js';
  // Muss zur zxing-wasm-Version passen, die der Build oben intern referenziert:
  var WASM_FALLBACK_BASE = 'https://cdn.jsdelivr.net/npm/zxing-wasm@3.1.1/dist/reader/';
  var detectorReady = null;

  // WASM vorladen mit automatischem Domain-Fallback: Der Build holt die
  // Datei standardmäßig von fastly.jsdelivr.net. Ist diese Domain geblockt
  // (Content-Blocker, DNS-Filter), wird auf cdn.jsdelivr.net ausgewichen –
  // von dort kam bereits das Polyfill-Script, die Domain ist also erreichbar.
  // Scheitern beide, landet der Fehler in window.__bcWasmError und wird
  // von der Scan-Schleife sichtbar gemacht.
  function prepareWasm(api) {
    function attempt(useFallback) {
      var p;
      try {
        p = api.prepareZXingModule(useFallback ? {
          overrides: {
            locateFile: function (path, prefix) {
              return /\.wasm$/i.test(path) ? WASM_FALLBACK_BASE + path : prefix + path;
            }
          },
          fireImmediately: true
        } : { fireImmediately: true });
      } catch (e) {
        window.__bcWasmError = e;
        return;
      }
      if (p && p.then) {
        p.then(function () {
          window.__bcWasm = useFallback ? 'ready (cdn-fallback)' : 'ready';
        }).catch(function (e) {
          if (!useFallback) { attempt(true); }
          else { window.__bcWasmError = e; }
        });
      }
    }
    attempt(false);
  }

  function ensureDetector() {
    if (detectorReady) return detectorReady;

    detectorReady = new Promise(function (resolve, reject) {
      var settled = false;
      var timeout = setTimeout(function () { fail(new Error('polyfill timeout')); }, 12000);

      function done(engine) {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        window.__bcEngine = engine; // Debug: 'native' | 'polyfill'
        resolve();
      }
      function fail(err) {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        detectorReady = null; // nächster Versuch darf neu laden
        reject(err);
      }

      function loadPolyfill() {
        // Klassischer Script-Load (kein ES-Modul): unsere Datei bleibt
        // reines ES5, und ein Parse-Fehler des Polyfills auf sehr alten
        // Geräten (Syntax-Floor ES2019, mit Shims oben ~iOS 12+) betrifft
        // nur das Polyfill-Script, nicht diese Datei.
        var s = document.createElement('script');
        s.src = POLYFILL_URL;
        s.async = true;
        s.onload = function () {
          var api = window.BarcodeDetectionAPI;
          if (api && api.BarcodeDetector) {
            // Explizit zuweisen (Ponyfill): überschreibt auch eine native,
            // aber funktionslose BarcodeDetector-API (Desktop-Chrome auf
            // Windows/Linux), die der Polyfill-Build nicht anfassen würde.
            window.BarcodeDetector = api.BarcodeDetector;
            // WASM eager vorladen (parallel zur Kamera-Berechtigungsabfrage),
            // inkl. automatischem Fallback auf cdn.jsdelivr.net.
            prepareWasm(api);
            done('polyfill');
          } else {
            fail(new Error('BarcodeDetectionAPI global fehlt nach dem Laden'));
          }
        };
        s.onerror = function () { fail(new Error('Polyfill-Script konnte nicht geladen werden (' + POLYFILL_URL + ')')); };
        document.head.appendChild(s);
      }

      if ('BarcodeDetector' in window && window.BarcodeDetector.getSupportedFormats) {
        // Auch prüfen, ob EAN-13 wirklich unterstützt wird: Desktop-Chrome
        // auf Windows/Linux hat die API teils ohne funktionierendes Backend.
        window.BarcodeDetector.getSupportedFormats()
          .then(function (formats) {
            if (formats && formats.indexOf('ean_13') !== -1) { done('native'); }
            else { loadPolyfill(); }
          })
          .catch(loadPolyfill);
      } else {
        loadPolyfill();
      }
    });

    return detectorReady;
  }

  function openScanner(input) {
    // Overlay sofort öffnen (User-Feedback), Detector parallel laden.
    var overlay = buildOverlay();
    ensureDetector()
      .then(function () { startScan(overlay, input); })
      .catch(function (err) {
        closeScanner(overlay);
        try { console.error('[bc-scanner]', err); } catch (e) {}
        alert('Der Barcode-Scanner konnte nicht geladen werden. Bitte prüfe die Internetverbindung.'
          + (err && err.message ? '\n\nDetails: ' + err.message : ''));
      });
  }

  function startScan(overlay, input) {
    var video = overlay.querySelector('video');
    var stream = null;
    var stopped = false;
    var stop = function () {
      stopped = true;
      if (stream) { try { stream.getTracks().forEach(function (t) { t.stop(); }); } catch (e) {} stream = null; }
    };
    activeStop = stop;

    // Höhere Wunschauflösung: kompensiert die Mindestfokusdistanz der
    // iPhone-Hauptkamera (~20 cm) – der Barcode kann weiter weg gehalten
    // werden und hat trotzdem genug Pixel für den Decoder.
    navigator.mediaDevices.getUserMedia({
      video: { facingMode: { ideal: 'environment' }, width: { ideal: 2560 }, height: { ideal: 1440 } }
    }).catch(function (err) {
      if (err && (err.name === 'OverconstrainedError' || err.name === 'NotFoundError')) {
        return navigator.mediaDevices.getUserMedia({ video: true });
      }
      throw err;
    }).then(function (s) {
      if (stopped) { s.getTracks().forEach(function (t) { t.stop(); }); return Promise.reject({ name: 'AbortError' }); }
      stream = s;
      video.srcObject = s;
      var p = video.play();
      return (p && p.then) ? p : Promise.resolve();
    }).then(function () {
      var detector;
      try { detector = new BarcodeDetector({ formats: ['ean_13'] }); }
      catch (e) { detector = new BarcodeDetector(); }

      // Analyse-Canvas: nur der Bildausschnitt im Scan-Rahmen wird
      // dekodiert (Overlay-Rahmen: inset 30% 8% -> 84% x 40%). Das ist
      // schneller (v.a. WASM auf älteren iPhones) und reduziert
      // Fehl-Lesungen durch Bildinhalte außerhalb des Rahmens.
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d', { willReadFrequently: true });

      // Dauerhafte detect()-Fehler dürfen nicht stumm geschluckt werden –
      // sonst ist "WASM lädt nicht" für den Nutzer identisch mit "kein
      // Barcode im Bild". Nach mehreren Fehlern in Folge wird abgebrochen
      // und die konkrete Ursache angezeigt.
      var failCount = 0;
      var lastErr = null;

      // Bestätigungslogik gegen Fehllesungen: Die EAN-Prüfziffer fängt nur
      // ~90 % zufälliger Fehldekodierungen ab. ZXing (Polyfill) liest bei
      // unscharfen oder Moiré-behafteten Frames gelegentlich falsch – der
      // Code muss deshalb 2x gelesen werden, bevor er akzeptiert wird.
      // MLKit (nativ, Android) stabilisiert intern selbst -> 1 Lesung,
      // Verhalten dort unverändert.
      var confirmationsNeeded = (window.__bcEngine === 'native') ? 1 : 2;
      var candidate = null;
      var candidateCount = 0;
      var candidateTime = 0;

      function giveUp(err) {
        var msg = (err && (err.message || String(err))) || 'unbekannt';
        closeScanner(overlay);
        try { console.error('[bc-scanner] detect fehlgeschlagen:', err); } catch (e) {}
        alert('Barcode-Erkennung nicht möglich.'
          + '\n\nDetails: ' + msg
          + (/wasm|webassembly|aborted|fetch/i.test(msg)
            ? '\n\nHinweis: Das deutet auf eine blockierte WASM-Datei hin (Content-Blocker / DNS-Filter) oder auf den aktivierten iPhone-Blockierungsmodus (Lockdown Mode).'
            : ''));
      }

      var scan = function () {
        if (stopped) return;
        if (window.__bcWasmError) { giveUp(window.__bcWasmError); return; }
        if (!video.videoWidth || video.readyState < 2) { setTimeout(scan, 100); return; }

        var vw = video.videoWidth, vh = video.videoHeight;
        var cw = Math.round(vw * 0.84), ch = Math.round(vh * 0.40);
        var sx = Math.round((vw - cw) / 2), sy = Math.round((vh - ch) / 2);
        var scale = Math.min(1, 1280 / cw);
        canvas.width = Math.round(cw * scale);
        canvas.height = Math.round(ch * scale);
        ctx.drawImage(video, sx, sy, cw, ch, 0, 0, canvas.width, canvas.height);

        detector.detect(canvas).then(function (codes) {
          if (stopped) return;
          failCount = 0;

          var found = null;
          for (var i = 0; i < codes.length; i++) {
            var code = normalize(codes[i].rawValue);
            if (isValidEan13(code)) { found = code; break; }
          }

          if (found) {
            var now = Date.now();
            // Veralteten Kandidaten verwerfen (z. B. Nutzer hat inzwischen
            // ein anderes Produkt vor die Kamera gehalten)
            if (candidate && now - candidateTime > 1500) { candidate = null; candidateCount = 0; }

            if (found === candidate) { candidateCount += 1; }
            else { candidate = found; candidateCount = 1; }
            candidateTime = now;

            if (candidateCount >= confirmationsNeeded) { accept(overlay, input, found); return; }
            setTimeout(scan, 50); // Bestätigung schnellstmöglich einholen
            return;
          }

          setTimeout(scan, 90);
        }).catch(function (err) {
          if (stopped) return;
          lastErr = err;
          failCount += 1;
          if (failCount >= 10) { giveUp(window.__bcWasmError || lastErr); return; }
          setTimeout(scan, 150);
        });
      };
      setTimeout(scan, 200);
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      closeScanner(overlay);
      alert('Kein Kamerazugriff möglich. Bitte erlaube den Kamerazugriff für diese Seite in den Browser-Einstellungen.');
    });
  }

  function buildOverlay() {
    var o = document.createElement('div');
    o.style.cssText = 'position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.92);display:flex;flex-direction:column;align-items:center;justify-content:center;';
    o.innerHTML = "<button type='button' data-bc-close aria-label='Schließen' style='position:absolute;top:1rem;right:1rem;width:2.75rem;height:2.75rem;border:0;border-radius:9999px;background:rgba(255,255,255,.15);color:#fff;font-size:1.6rem;line-height:1;cursor:pointer;'>&times;</button><div style='position:relative;width:min(92vw,460px);aspect-ratio:4/3;border-radius:1rem;overflow:hidden;background:#000;'><video playsinline muted autoplay style='width:100%;height:100%;object-fit:cover;'></video><div style='position:absolute;inset:30% 8%;border:2px solid rgba(255,255,255,.9);border-radius:.5rem;box-shadow:0 0 0 100vmax rgba(0,0,0,.4);'></div></div><p style='color:#fff;margin-top:1.25rem;font-size:.95rem;text-align:center;max-width:80vw;'>EAN-13/Barcode in den Rahmen halten &ndash; Abstand ca. 20&#8211;25&nbsp;cm</p>";
    document.body.appendChild(o);
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = o.querySelector('[data-bc-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { closeScanner(o); });
    return o;
  }
})();